import http from '@/utils/http'
import _ from 'lodash'
import { INTERFACE } from '@/utils/INTERFACE'
import { getSystem } from '@/utils/site'
import { getParams } from '@/utils/zgb'
import {SplitQueue} from '@/utils/queue'

export async function getGoods(skus,isJshop) {
    skus = _.uniq(skus).filter(id => !!id)
    if (!skus.length) {
        return []
    }
    var goods = []
    var sys = getSystem()
    if (sys == 'EJSHOP') {
        var api=INTERFACE().goods
        if(isJshop){
            api=INTERFACE().goodsForJshop
        }
        var queue=new SplitQueue(async chunk=>{ 
            let res = await http.jsonp.get(api, getParams({
                "skuIds": chunk.join(",")
            }))
            return res.data.wareInfoList||[]
        },20)
        let data=await queue.fetch(skus)
        goods = data.map(it => ({
            id: parseInt(it.skuId),
            name: it.name,
            imgUrl: it.imageUrl,
            jdPrice: (it.price=='暂无定价'||it.jdPrice=='暂无定价'||parseFloat(it.price)<=parseFloat(it.jdPrice))?null:it.price,
            price: it.jdPrice,
            addCart:it.addCart,
            produceDate:it.produceDate,
        }))
    } else {
        let res = await http.get(INTERFACE().goods, {
            recGoodsId: skus.join(",")
        })
        goods = res.goodsList.map(it => ({
            adwordContent: it.adwordContent,
            imgUrl: it.imgUrl,
            name: it.name,
            id: parseInt(it.skuId)
        }))
    }
    return goods
}